<template>
  <div>
    <el-select :class="mode ? 'input__day' : 'input__night'" :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.device_type')" filterable clearable 
      :size="size" class="d-block">
      <el-option v-for="(device_type,index) in device_types" :key="'device_types-' + index" :label="device_type.device_type_name" :value="device_type.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
          default: null
        },
        // multiple:{
        //     type: Boolean,
        //     default: false,
        // }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.device_types && this.device_types.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        device_types: 'deviceType/inventory',
        mode:'MODE'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'deviceType/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
